/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.mylearning.bff.rpc.MyLearningBFFChirpService
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
import * as References from './MyLearningBFFChirpService';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.mylearning.bff.rpc.MyLearningBFFChirpService#getProgressItemsForMyLearningPage
 */
export const GET_PROGRESS_ITEMS_FOR_MY_LEARNING_PAGE_QUERY = /* #__PURE__ */registerQuery({
  fieldName: 'getProgressItemsForMyLearningPage',
  args: ['searchTerm', 'hasCertification', 'progressType', 'contentTypes', 'includePlaylistProgress', 'pageLength', 'offset'],
  fetcher(request) {
    return chirpClient.call(References.getProgressItemsForMyLearningPageRpc, {
      request
    });
  }
});